// src/moment/components/Jokes/JokeCard.tsx

import { FC } from 'react';
import './JokeCard.scss';

// Export the interface for use in tests and stories
export interface JokeCardProps {
  setup: string;
  punchline: string;
  isRevealed: boolean;
  onToggleReveal: () => void;
}

const JokeCard: FC<JokeCardProps> = ({
                                       setup,
                                       punchline,
                                       isRevealed,
                                       onToggleReveal,
                                     }) => {
  const handleCardClick = () => {
    onToggleReveal();
  };

  return (
    <div
      // Add a test ID for reliable selection in tests
      data-testid="joke-card"
      className={`joke-card ${isRevealed ? 'is-revealed' : ''}`}
      onClick={handleCardClick}
    >
      <div className="joke-card__content">
        <p className="joke-card__setup">{setup}</p>
        <p className="joke-card__punchline">{punchline}</p>
      </div>
    </div>
  );
};

export default JokeCard;
